import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MinimalRouterStateSnapshot, RouterStateSerializer } from '@ngrx/router-store';

export interface MinimalActivatedRouteSnapshot {
   routeConfig: ActivatedRouteSnapshot['routeConfig'];
   url: ActivatedRouteSnapshot['url'];
   params: ActivatedRouteSnapshot['params'];
   queryParams: ActivatedRouteSnapshot['queryParams'];
   fragment: ActivatedRouteSnapshot['fragment'];
   data: ActivatedRouteSnapshot['data'];
   outlet: ActivatedRouteSnapshot['outlet'];
   firstChild?: MinimalActivatedRouteSnapshot;
   children: MinimalActivatedRouteSnapshot[];
   title: string;
}

export interface ExtendedRouterStateSnapshot extends MinimalRouterStateSnapshot {
   root: MinimalActivatedRouteSnapshot;
   url: string;
   path: string[];
}

/**
 * RouterStateSerializer that serializes the full path (e.g., ['path','to','route'])
 * in addition to the default {@link MinimalRouterStateSnapshot}
 */
export class ExtendedRouterStateSerializer implements RouterStateSerializer<ExtendedRouterStateSnapshot> {
   serialize(routerState: RouterStateSnapshot): ExtendedRouterStateSnapshot {
      let node: ActivatedRouteSnapshot = routerState.root;
      const path: string[] = node.url.map((segment) => {
         return segment.path;
      });
      while (node.firstChild) {
         node = node.firstChild;
         path.push(
            ...node.url.map((segment) => {
               return segment.path;
            })
         );
      }

      return {
         path,
         root: this.serializeRoute(routerState.root),
         url: routerState.url,
      };
   }

   private serializeRoute(route: ActivatedRouteSnapshot): MinimalActivatedRouteSnapshot {
      const children = route.children.map((c) => {
         return this.serializeRoute(c);
      });
      return {
         children,
         data: route.data,
         firstChild: children[0],
         // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
         fragment: route.fragment!,
         outlet: route.outlet,
         params: route.params,
         queryParams: route.queryParams,
         routeConfig: route.routeConfig
            ? {
                 outlet: route.routeConfig.outlet,
                 path: route.routeConfig.path,
                 pathMatch: route.routeConfig.pathMatch,
                 redirectTo: route.routeConfig.redirectTo,
              }
            : null,
         url: route.url,
         title: route.title ?? '',
      };
   }
}
